"use strict";
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isExitToLevelGenSignaled = exports.signal_flung = exports.signal_gameReset = exports.signal_newLevel = exports.reset = exports.get = exports.start = void 0;
var onceOnly_1 = require("@lib/onceOnly");
var generatorManager_sidecar_1 = require("../to-engine/generatorManager-sidecar");
var physicsTickManager_sidecar_1 = require("../to-engine/physicsTickManager-sidecar");
var syncedId_sidecar_1 = require("../to-engine/syncedId-sidecar");
var syncedRando_sidecar_1 = require("../to-engine/syncedRando-sidecar");
var minigolfGen_enemyTurn_sidecar_1 = require("./minigolfGen_enemyTurn-sidecar");
var minigolfGen_loading_sidecar_1 = require("./minigolfGen_loading-sidecar");
var minigolfGen_newLevel_sidecar_1 = require("./minigolfGen_newLevel-sidecar");
var minigolfGen_waitForEnemySettle_sidecar_1 = require("./minigolfGen_waitForEnemySettle-sidecar");
var minigolfGen_waitForPlayerFling_sidecar_1 = require("./minigolfGen_waitForPlayerFling-sidecar");
var minigolfGen_waitForPlayerSettle_sidecar_1 = require("./minigolfGen_waitForPlayerSettle-sidecar");
var minigolf_bufferedCommands_sidecar_1 = require("./minigolf_bufferedCommands-sidecar");
var minigolfGameState_sidecar_1 = require("./minigolfGameState-sidecar");
var start = function () {
    onceOnly_1.ensureCalledOnlyOnce('minigolfMainGameGenerator.start');
    generatorManager_sidecar_1.generatorManager.setGenerator(gen_run());
};
exports.start = start;
var _obj = null;
var get = function () {
    if (!_obj) {
        _obj = {
            signal_newLevel: false,
            signal_flung: false,
            signal_gameReset: true,
        };
        exports.reset();
    }
    return _obj;
};
exports.get = get;
var reset = function () {
    var obj = exports.get();
    syncedRando_sidecar_1.syncedRando.reset();
    syncedId_sidecar_1.syncedId.reset(100);
    physicsTickManager_sidecar_1.physicsTickManager.reset();
    minigolf_bufferedCommands_sidecar_1.minigolf_bufferedCommands.reset();
    minigolfGameState_sidecar_1.minigolfGameState.reset();
    obj.signal_newLevel = true;
};
exports.reset = reset;
function gen_run() {
    var newLevelGen;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [5 /*yield**/, __values(minigolfGen_loading_sidecar_1.minigolfGen_loading.gen_run_loading())];
            case 1:
                _a.sent();
                physicsTickManager_sidecar_1.physicsTickManager.reset();
                _a.label = 2;
            case 2:
                if (!true) return [3 /*break*/, 14];
                if (exports.get().signal_gameReset) {
                    exports.get().signal_gameReset = false;
                    exports.reset();
                }
                exports.get().signal_newLevel = false;
                return [5 /*yield**/, __values(minigolfGen_newLevel_sidecar_1.minigolfGen_newLevel.gen_run_newLevel())
                    // if (!get().signal_newLevel) {
                    // Add our par on exit level
                    //   // Add our level par
                    //   minigolfGameState.get().playerState.food +=
                    //     minigolfGameState.get().playerState.levelPar
                    // }
                ];
            case 3:
                _a.sent();
                newLevelGen = true;
                _a.label = 4;
            case 4:
                if (!!exports.get().signal_newLevel) return [3 /*break*/, 12];
                if (exports.isExitToLevelGenSignaled()) {
                    return [3 /*break*/, 12];
                }
                if (newLevelGen) {
                    // Add some food for going down a level
                    //  based on level par
                    minigolfGameState_sidecar_1.minigolfGameState.get().playerState.food +=
                        minigolfGameState_sidecar_1.minigolfGameState.get().playerState.levelPar;
                    newLevelGen = false;
                }
                return [5 /*yield**/, __values(minigolfGen_waitForPlayerFling_sidecar_1.minigolfGen_waitForPlayerFling.gen_run_waitForPlayerFling())];
            case 5:
                _a.sent();
                if (exports.isExitToLevelGenSignaled()) {
                    return [3 /*break*/, 12];
                }
                return [5 /*yield**/, __values(minigolfGen_waitForPlayerSettle_sidecar_1.minigolfGen_waitForPlayerSettle.gen_run_waitForPlayerSettle())];
            case 6:
                _a.sent();
                return [4 /*yield*/, 0];
            case 7:
                _a.sent();
                if (exports.isExitToLevelGenSignaled()) {
                    return [3 /*break*/, 12];
                }
                return [5 /*yield**/, __values(minigolfGen_enemyTurn_sidecar_1.minigolfGen_enemyTurn.gen_run_enemyTurn())];
            case 8:
                _a.sent();
                return [4 /*yield*/, 0];
            case 9:
                _a.sent();
                if (exports.isExitToLevelGenSignaled()) {
                    return [3 /*break*/, 12];
                }
                return [5 /*yield**/, __values(minigolfGen_waitForEnemySettle_sidecar_1.minigolfGen_waitForEnemySettle.gen_run_waitForEnemySettle())];
            case 10:
                _a.sent();
                return [4 /*yield*/, 0];
            case 11:
                _a.sent();
                if (exports.isExitToLevelGenSignaled()) {
                    return [3 /*break*/, 12];
                }
                return [3 /*break*/, 4];
            case 12: return [4 /*yield*/, 0];
            case 13:
                _a.sent();
                return [3 /*break*/, 2];
            case 14: return [2 /*return*/, 0];
        }
    });
}
var signal_newLevel = function () {
    exports.get().signal_newLevel = true;
};
exports.signal_newLevel = signal_newLevel;
var signal_gameReset = function () {
    exports.get().signal_gameReset = true;
};
exports.signal_gameReset = signal_gameReset;
var signal_flung = function () {
    exports.get().signal_flung = true;
};
exports.signal_flung = signal_flung;
var isExitToLevelGenSignaled = function () {
    return exports.get().signal_newLevel || exports.get().signal_gameReset;
};
exports.isExitToLevelGenSignaled = isExitToLevelGenSignaled;
